
interface StepCardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  description?: string;
  icon?: string;
}

const StepCard = ({ children, className = '', title, description, icon }: StepCardProps) => {
  return (
    <div className={`
      bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 md:p-8
      transition-all duration-200 hover:border-white/20
      ${className}
    `}>
      {(title || description) && (
        <div className="mb-6">
          {title && (
            <div className="flex items-center gap-3 mb-2">
              {icon && (
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#FFD700]/10">
                  <i className={`${icon} text-[#FFD700] text-lg`}></i>
                </div>
              )}
              <h3 className="text-white text-lg font-semibold">{title}</h3>
            </div>
          )}
          {description && (
            <p className="text-white/90 text-sm">{description}</p>
          )}
        </div>
      )}
      {children}
    </div>
  );
};

export default StepCard;
